import Cookies from 'js-cookie'
const TokenKey = 'XAdmin-Token'
const ExpiresInKey = 'XAdmin-Expires-In'
const UserType = 'XAdmin-User-Type'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getExpiresIn() {
  return Cookies.get(ExpiresInKey) || -1
}

export function setExpiresIn(time) {
  return Cookies.set(ExpiresInKey, time)
}

export function removeExpiresIn() {
  return Cookies.remove(ExpiresInKey)
}

export function getUserType() {
  return Cookies.get(UserType) || 0
}

export function setUserType(type) {
  return Cookies.set(UserType, type)
}

export function removeUserType() {
  return Cookies.remove(UserType)
}